module.exports = __webpack_public_path__ + "img/logo_dark.073ee3d5.svg";